export const palette = {
  // Backgrounds
  background: {
    default: '#1a1a2e',
    paper: '#232340',
  },
  navigation: {
    background: '#16162a',
  },

  // Text
  text: {
    primary: '#ffffff',
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
  },

  // Brand
  primary: {
    main: '#e8914f',
    light: '#faa569',
    dark: '#cc7d3d',
  },
  secondary: {
    main: '#320CC9',
    light: '#5A3FD9',
    lighter: '#af9eff',
    dark: '#2509A0',
  },

  // Semantic
  success: '#66BB6A',
  warning: '#FFA726',
  error: '#F44336',
  info: '#29B6F6',
} as const;
